import React, { FC } from 'react';
import { HeadingOne, Paragraph } from 'hui';

const RemindArea: FC<{}> = () => (
  <>
    <HeadingOne>hipages data upload service</HeadingOne>
    <Paragraph bold>Let’s get started!</Paragraph>
    <ul>
      <li>You can upload a single CSV file at a time</li>
      <li>The size limit is 10Mb per file</li>
      <li>The file will be parsed in real time</li>
      <li>If there are errors with the file being uploaded, these will be shown below</li>
    </ul>
  </>
);

export default RemindArea;
